var _a;
import { ChainId } from '@sushiswap/chain';
var drpcId = process.env['DRPC_ID'] || process.env['NEXT_PUBLIC_DRPC_ID'];
export var rpcUrls = (_a = {},
    _a[ChainId.ARBITRUM_NOVA] = ["https://lb.drpc.org/ogrpc?network=arbitrum-nova&dkey=".concat(drpcId)],
    _a[ChainId.ARBITRUM] = ["https://lb.drpc.org/ogrpc?network=arbitrum&dkey=".concat(drpcId)],
    _a[ChainId.AVALANCHE] = ["https://lb.drpc.org/ogrpc?network=avalanche&dkey=".concat(drpcId)],
    _a[ChainId.BASE] = ["https://lb.drpc.org/ogrpc?network=base&dkey=".concat(drpcId)],
    _a[ChainId.BOBA] = ['https://mainnet.boba.network'],
    _a[ChainId.BOBA_BNB] = ['https://bnb.boba.network'],
    _a[ChainId.BSC] = ["https://lb.drpc.org/ogrpc?network=bsc&dkey=".concat(drpcId)],
    _a[ChainId.BTTC] = ['https://rpc.bittorrentchain.io'],
    _a[ChainId.CELO] = ["https://lb.drpc.org/ogrpc?network=celo&dkey=".concat(drpcId)],
    _a[ChainId.ETHEREUM] = ["https://lb.drpc.org/ogrpc?network=ethereum&dkey=".concat(drpcId)],
    _a[ChainId.FANTOM] = ["https://lb.drpc.org/ogrpc?network=fantom&dkey=".concat(drpcId)],
    // [ChainId.FILECOIN]: [`https://lb.drpc.org/ogrpc?network=filecoin&dkey=${drpcId}`],
    _a[ChainId.FUSE] = ["https://lb.drpc.org/ogrpc?network=fuse&dkey=".concat(drpcId)],
    _a[ChainId.GNOSIS] = ["https://lb.drpc.org/ogrpc?network=gnosis&dkey=".concat(drpcId)],
    _a[ChainId.HARMONY] = ["https://lb.drpc.org/ogrpc?network=harmony-0&dkey=".concat(drpcId)],
    _a[ChainId.KAVA] = ["https://lb.drpc.org/ogrpc?network=kava&dkey=".concat(drpcId)],
    _a[ChainId.METIS] = ["https://lb.drpc.org/ogrpc?network=metis&dkey=".concat(drpcId)],
    _a[ChainId.MOONBEAM] = ["https://lb.drpc.org/ogrpc?network=moonbeam&dkey=".concat(drpcId)],
    _a[ChainId.MOONRIVER] = ["https://lb.drpc.org/ogrpc?network=moonriver&dkey=".concat(drpcId)],
    _a[ChainId.OPTIMISM] = ["https://lb.drpc.org/ogrpc?network=optimism&dkey=".concat(drpcId)],
    _a[ChainId.POLYGON] = ["https://lb.drpc.org/ogrpc?network=polygon&dkey=".concat(drpcId)],
    _a[ChainId.POLYGON_ZKEVM] = ["https://lb.drpc.org/ogrpc?network=polygon-zkevm&dkey=".concat(drpcId)],
    _a[ChainId.THUNDERCORE] = ['https://mainnet-rpc.thundercore.com'],
    _a[ChainId.HAQQ] = ["https://lb.drpc.org/ogrpc?network=haqq&dkey=".concat(drpcId)],
    _a[ChainId.CORE] = ['https://rpc.coredao.org'],
    _a[ChainId.TELOS] = ['https://rpc1.us.telos.net/evm'],
    _a[ChainId.LINEA] = ["https://lb.drpc.org/ogrpc?network=linea&dkey=".concat(drpcId)],
    _a);
//# sourceMappingURL=rpc-urls.js.map